module.exports = __webpack_public_path__ + "img/offsite1.06786c9b.png";